import { GroupType } from "../types/group.type";
import { formatDateDisplay, numeralCustom } from "./helpers";
import FilterCRThuoc from "../components/common/filter/group/crthuoc/FilterCRThuoc";

const groups: { [key: string]: GroupType } = {
  cr_thuoc: {
    title: "Báo cáo truy xuất kết quả tìm kiếm",
    apiCode: "fos_tonghopgiacr",
    apiCodeList: "cr_thuoc",
    fastFields: [],
    allowFilter: true,
    showExclued: false,
    Filter: FilterCRThuoc,
    columns: [
      {
        name: "ID (BV)",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.id,
      },
      {
        name: "Tên thuốc",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ten_thuoc,
      },
      {
        name: "Đơn giá",
        width: "150px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.dongia,
        format: (row) =>
          row.dongia ? numeralCustom(row.dongia).format() : "Chưa xác định",
      },
      {
        name: "Tên hoạt chất",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hoat_chat,
      },
      {
        name: "Hàm lượng",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.hamluong,
      },
      {
        name: "GĐKLH hoặc GPNK",
        width: "180px",
        reorder: true,
        sortable: true,
        selector: (row) => row.gdklh,
      },
      {
        name: "Đường dùng",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.duongdung,
      },
      {
        name: "Dạng bào chế",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.baoche,
      },
      {
        name: "Nhóm thuốc",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nhomthuoc,
      },
      {
        name: "Cơ sở SX",
        width: "150px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cssx,
      },
      {
        name: "Nước SX",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.nuocsx,
      },
      {
        name: "Quy cách",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.quycach,
      },
      {
        name: "ĐVT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.dvt,
      },
      {
        name: "Số lượng",
        width: "120px",
        reorder: true,
        sortable: true,
        right: true,
        selector: (row) => row.soluong,
      },
      {
        name: "Mã TBMT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.tbmt,
      },
      {
        name: "Tên CĐT",
        width: "120px",
        reorder: true,
        sortable: true,
        selector: (row) => row.cdt,
      },
      {
        name: "Ngày đăng tải KQLCNT",
        width: "210px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngay_kqlcnt,
        format: (row) => formatDateDisplay(row.ngay_kqlcnt, "DD/MM/YYYY"),
      },
      {
        name: "Số QĐ",
        width: "140px",
        reorder: true,
        sortable: true,
        selector: (row) => row.soquyetdinh,
      },
      {
        name: "Ngày ban hành QĐ",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.ngayquyetdinh,
        format: (row) => formatDateDisplay(row.ngayquyetdinh, "DD/MM/YYYY"),
      },
      {
        name: "Nhà thầu tham dự",
        width: "180px",
        reorder: true,
        sortable: true,
        selector: (row) => row.slnhathau,
      },
      {
        name: "Địa điểm",
        width: "200px",
        reorder: true,
        sortable: true,
        selector: (row) => row.diadiem,
      },
    ],
  },
};

export { groups };
